import { authFetchInit } from './authSession';
import { API_ROOT } from '../config/apiConfig';

export interface VysorQuickAction {
  id: string;
  label: string;
  description: string;
  actionType: 'wizard' | 'navigate';
  flowId?: 'setup-app' | 'iga-entitlements' | 'configure-sso';
  path?: string;
}

export interface VysorAppInstance {
  id: string;
  name: string;
  environment: string;
  sso_status: string | null;
}

export interface VysorAppCatalogItem {
  id: string;
  name: string;
  application_slug?: string;
  risk_level?: string;
  business_function?: string;
  description?: string;
  instances: VysorAppInstance[];
}

export interface VysorIdpOption {
  id: string;
  label: string;
}

export interface VysorAssistantContext {
  quickActions: VysorQuickAction[];
  applications: VysorAppCatalogItem[];
  configuredIdps: VysorIdpOption[];
  stats: {
    totalApps: number;
    totalInstances: number;
    pendingSso: number;
  };
}

export async function fetchVysorContext(): Promise<VysorAssistantContext> {
  const res = await fetch(`${API_ROOT}/assistant/context`, authFetchInit());
  const json = await res.json();
  if (!res.ok || !json.success) {
    throw new Error(json.error || 'Failed to load VYSOR context');
  }
  return json.data as VysorAssistantContext;
}

export function isInstancePendingSso(ssoStatus: string | null | undefined): boolean {
  return !ssoStatus || ssoStatus === 'Not Started' || ssoStatus === 'Pending';
}

export function findApp(catalog: VysorAppCatalogItem[], applicationId: string): VysorAppCatalogItem | undefined {
  return catalog.find(a => a.id === applicationId);
}

export function instancesForField(
  catalog: VysorAppCatalogItem[],
  collected: Record<string, string>,
  filter: 'all' | 'pending-sso' = 'all',
): VysorAppInstance[] {
  const app = findApp(catalog, collected.application_id || '');
  if (!app) return [];
  const list = app.instances || [];
  if (filter === 'pending-sso') {
    return list.filter(i => isInstancePendingSso(i.sso_status));
  }
  return list;
}
